import { useContext } from 'react';
import { ModalContext, Modals } from '@taxdown/piccolo-web';
import { locizeNS } from 'Services/i18n';
import useTranslation from 'Hooks/useTranslation';
import { TAXDOWN_ASSETS_DOMAIN } from 'Constants/domains';
import { openLinkInNewTab } from 'Utils/links';

const SAT_HELP_URL = 'https://www.siat.sat.gob.mx/PTSC/auth/faces/pages/validar/pwdGobMx.jsf';

const LimitErrorsModal = (): JSX.Element => {
  const { t } = useTranslation(locizeNS.DG);
  const { hideModal } = useContext(ModalContext);

  return (
    <Modals.Centered
      maxSize="S"
      title={t('Dg.limitErrorsModal.title')}
      description={t('Dg.limitErrorsModal.description')}
      urlImage={`${TAXDOWN_ASSETS_DOMAIN}/illustrations/default/search_s.png`}
      buttonsInline
      buttonsAlign="center"
      onClose={hideModal}
      primaryButton={{
        label: t('Dg.limitErrorsModal.primaryButton'),
        onClick: () => {
          openLinkInNewTab(SAT_HELP_URL);
          hideModal();
        },
      }}
    />
  );
};

export default LimitErrorsModal;
